import { PaymentsIntegrationEnum } from "../../Contracts/Integration";

export const connectIntegration = (
  integration: PaymentsIntegrationEnum,
  userSub?: string
): void => {
  const userId = userSub?.replace("auth0|", "");
  if (!userId) {
    throw new Error("Constraint violation! User id missing!");
  }

  if (integration === PaymentsIntegrationEnum.Xero) {
    const xeroConnectURL = process.env.REACT_APP_XERO_CONNECT_URL;
    const xeroClientId = process.env.REACT_APP_XERO_CLIENT_ID;
    const redirectUrl = `${process.env.REACT_APP_API_HOST}/v1/payments/xero/auth/callback/`;
    if (xeroConnectURL && xeroClientId) {
      const scope =
        "openid email profile offline_access accounting.settings accounting.transactions accounting.contacts bankfeeds";
      const encodedRedirectUrl = encodeURIComponent(redirectUrl);
      const encodedScope = encodeURIComponent(scope);
      const encodedUserId = encodeURIComponent(userId);
      const encodedClientId = encodeURIComponent(xeroClientId);
      window.location.href = `${xeroConnectURL}?scope=${encodedScope}&state=${encodedUserId}&response_type=code&approval_prompt=auto&redirect_uri=${encodedRedirectUrl}&client_id=${encodedClientId}`;
    } else {
      throw new Error("Constraint violation! Either connect url or clientId is missing!");
    }
  } else if (integration === PaymentsIntegrationEnum.Quickbooks) {
    const qboConnectURL = process.env.REACT_APP_QBO_CONNECT_URL;
    const qboClientId = process.env.REACT_APP_QBO_CLIENT_ID;
    const redirectUrl = `${process.env.REACT_APP_API_HOST}/v1/payments/quickbooks/auth/callback/`;
    if (qboConnectURL && qboClientId) {
      const scope = "com.intuit.quickbooks.accounting";
      const locale = "en-gb";
      const encodedRedirectUrl = encodeURIComponent(redirectUrl);
      const encodedScope = encodeURIComponent(scope);
      const encodedLocale = encodeURIComponent(locale);
      const encodedUserId = encodeURIComponent(userId);
      const encodedClientId = encodeURIComponent(qboClientId);
      window.location.href = `${qboConnectURL}?redirect_uri=${encodedRedirectUrl}&scope=${encodedScope}&locale=${encodedLocale}&state=${encodedUserId}&client_id=${encodedClientId}&response_type=code`;
    } else {
      throw new Error("Constraint violation! Either connect url or clientId is missing!");
    }
  }
};
